/**
 * SanCanDo hats/apparel under-media color chips.
 * Deferred external script — place picker under gallery, enhance with CSS hex/gradients only.
 * Antifreeze: no dual aggressive MOs, no media=print CSS, no bg-image swatches, idle+rAF boot.
 */
(function () {
  if (window.__sancandoHatsColorBound) return;
  window.__sancandoHatsColorBound = true;

  var COLOR_HEX = {
    ash: "#d3d4d9",
    garnet: "#76232f",
    "dark chocolate": "#382e2c",
    "dark heather": "#3d464d",
    advantage: "#5a6b3e",
    alloy: "#7a7a7a",
    "alloy gray": "#7a7a7a",
    "alloy grey": "#7a7a7a",
    allure: "#8b9dc3",
    aluminum: "#a8a9ad",
    amber: "#c9a227",
    "amber gold": "#c9a227",
    "anchor gray": "#a8a8a8",
    "anchor grey": "#a8a8a8",
    anthracite: "#2e2e2e",
    "apple green": "#8db600",
    arid: "#c2a878",
    "army green": "#4b5320",
    "army olive": "#556b2f",
    athletic: "#9aa0a6",
    "athletic green": "#2e8b57",
    "athletic heather": "#9e9e9e",
    "athletic oxford": "#9aa0a6",
    "bark duck camo": "#6b5344",
    bay: "#5f9ea0",
    beach: "#e8dcc8",
    bean: "#3b2f2f",
    beige: "#f5f5dc",
    berry: "#8e4585",
    birch: "#d9d2c5",
    biscuit: "#d2b48c",
    black: "#1a1a1a",
    "black camo": "#2a2a2a",
    "black dip dye": "#1a1a1a",
    "black heather": "#3a3a3a",
    "black silver": "#4a4a4a",
    blacktop: "#1c1c1c",
    blaze: "#ff6600",
    "blaze duck camo": "#ff6600",
    "blizzard duck camo": "#8a9a9a",
    blossom: "#f9c5d1",
    "blue crush": "#1e90ff",
    "blue jean": "#5b7c99",
    "blue mist": "#a0b8c8",
    "blue mist heather": "#a0b8c8",
    "blue moon": "#5b7c99",
    "blue nights": "#1a2744",
    "blue stripe": "#1e4d8c",
    "blue teal": "#0a7a7a",
    "blue wing": "#3a5f8a",
    bottomland: "#3d4a2e",
    "break-up": "#4f5d3a",
    "break-up country": "#5c6840",
    "bright seafoam": "#66cdaa",
    "brilliant blue": "#1e90ff",
    brite: "#bfff00",
    "brite lime": "#bfff00",
    brown: "#5c4033",
    buck: "#8b5a2b",
    burgundy: "#800020",
    "burnt olive": "#4a5c2e",
    "burnt olive green": "#4a5c2e",
    butter: "#f5d76e",
    camo: "#556b2f",
    canvas: "#e8dcc8",
    caps: "#e8e8e8",
    caramel: "#af6e4d",
    cardinal: "#8c1d2c",
    "carolina blue": "#7ba4db",
    carrot: "#e87722",
    "chalky mint": "#c5e1d4",
    chambray: "#a0b2c2",
    charcoal: "#3d3d3d",
    "charcoal gray": "#3d3d3d",
    "charcoal grey": "#3d3d3d",
    "charcoal heather": "#5a5a5a",
    china: "#1e4d8c",
    "china blue": "#1e4d8c",
    "chocolate chip": "#4a3728",
    chrome: "#dbdbdb",
    city: "#5a5a5a",
    "city street": "#5a5a5a",
    cloud: "#a0c4e8",
    "cloud blue": "#a0c4e8",
    coal: "#36454f",
    "coal heather": "#4a555c",
    "cobalt blue": "#0047ab",
    coffee: "#4b3621",
    "coffee bean": "#3b2f2f",
    "columbia blue": "#6ba3d0",
    concrete: "#8a8a8a",
    cooked: "#e87722",
    "cooked carrot": "#e87722",
    "cool blue": "#6ba3d0",
    country: "#5c6840",
    cream: "#f5f0e1",
    crimson: "#dc143c",
    crush: "#1e90ff",
    "cyber green": "#00ff7f",
    dandelion: "#f0e130",
    "dark forest green": "#014421",
    "dark gray": "#4a4a4a",
    "dark gray heather": "#4a4a4a",
    "dark green": "#0b3d2e",
    "dark grey": "#4a4a4a",
    "dark grey heather": "#4a4a4a",
    "dark orange": "#c45a10",
    "deep smoke": "#555555",
    denim: "#1560bd",
    "denim blue": "#1560bd",
    "desert camo": "#c2a878",
    digi: "#002868",
    digital: "#5a6b4a",
    "digital camo": "#5a6b4a",
    "dip dye": "#1a1a1a",
    drab: "#6b8e23",
    "dress blue navy": "#1a2744",
    "dress blue navy heather": "#2a3a5c",
    "duck camo": "#6b7a4a",
    dusk: "#4a5568",
    ecru: "#c2b280",
    edge: "#4a5c3a",
    espresso: "#3c2415",
    "faded blue": "#6a8caf",
    flag: "#c41e3a",
    "flag army": "#4b5320",
    "flag camo": "#4a5a3a",
    "flag dark green": "#014421",
    "flag graphite": "#4a4e51",
    "flag scarlet": "#c41e3a",
    "flag stone": "#c2b8a3",
    forest: "#228b22",
    "forest green": "#228b22",
    gargoyle: "#6a6a6a",
    "gargoyle gray heather": "#6a6a6a",
    "gargoyle grey heather": "#6a6a6a",
    glo: "#ff6ec7",
    gold: "#d4af37",
    "gorge green": "#2e5a3c",
    granite: "#676767",
    graphite: "#4a4e51",
    gravel: "#8b8680",
    gray: "#8a8a8a",
    "gray camo": "#7a7a7a",
    "gray concrete": "#8a8a8a",
    "gray heather": "#9e9e9e",
    "gray smoke": "#8a8a8a",
    "gray smoke heather": "#8a8a8a",
    "gray steel": "#8a9196",
    green: "#228b22",
    "green camo": "#556b2f",
    "green oasis": "#3cb371",
    grey: "#8a8a8a",
    "grey brown": "#6b5b4f",
    "grey camo": "#7a7a7a",
    "grey concrete": "#8a8a8a",
    "grey heather": "#9e9e9e",
    "grey smoke": "#8a8a8a",
    "grey smoke heather": "#8a8a8a",
    "grey steel": "#8a9196",
    gunmetal: "#5a6368",
    "gunmetal gray": "#5a6368",
    "gunmetal grey": "#5a6368",
    "gym blue": "#2a5cad",
    hardwoods: "#6b5b3e",
    "harvest duck camo": "#8b6914",
    heather: "#9e9e9e",
    "heather graphite": "#6a6e71",
    "heather grey": "#9e9e9e",
    highlander: "#8a7a4a",
    "hot pink": "#ff69b4",
    hunter: "#355e3b",
    "hunter green": "#355e3b",
    hydrangea: "#8b9dc3",
    indigo: "#3a4a6a",
    "insignia blue": "#1c3a5f",
    ivory: "#fffff0",
    jean: "#5b7c99",
    kelly: "#009e60",
    "kelly green": "#009e60",
    khaki: "#c3b091",
    kryptek: "#8a7a4a",
    "kryptek highlander": "#8a7a4a",
    "kryptek typhon": "#2f2f2f",
    lagoon: "#4a90a4",
    "lagoon blue": "#4a90a4",
    leaf: "#6b8e4e",
    "legion blue": "#2f4f6f",
    "light anchor grey": "#a8a8a8",
    "light anchor grey heather": "#a8a8a8",
    "light blue": "#9ec9e8",
    "light bronze": "#cd7f32",
    "light gray heather": "#c8c8c8",
    "light green": "#90ee90",
    "light grey": "#c8c8c8",
    "light grey heather": "#c8c8c8",
    "light tan": "#d2b48c",
    lilac: "#c8a2c8",
    lime: "#32cd32",
    loden: "#5c6b4a",
    lucid: "#39ff14",
    "lucid green": "#39ff14",
    lucky: "#2e8b57",
    "lucky green": "#2e8b57",
    magnet: "#4a4a4a",
    maroon: "#6b1e2a",
    "marsh duck camo": "#6b7a4a",
    marshmallow: "#f5f0e6",
    "max-7": "#5a6b3e",
    "medium gray": "#8a8a8a",
    "medium grey": "#8a8a8a",
    melange: "#6a7a9a",
    "melange blue": "#6a7a9a",
    "melange silver": "#b0b0b0",
    "midnight heather": "#1a1a2e",
    "military camo": "#5b6b3f",
    milk: "#f5e6c8",
    millennium: "#1e4d8c",
    "millennium blue": "#1e4d8c",
    mink: "#c4a484",
    "mink beige": "#c4a484",
    mist: "#c4c4c4",
    moon: "#5b7c99",
    moss: "#8a9a5b",
    "moss green": "#8a9a5b",
    "mossy oak": "#4f5d3a",
    "mossy oak bottomland": "#3d4a2e",
    "mossy oak break-up country": "#5c6840",
    "mossy oak new break-up": "#4f5d3a",
    multicam: "#8a7d5a",
    "multicam arid": "#c2a878",
    natural: "#e8dcc8",
    navy: "#13294b",
    "navy blue": "#13294b",
    "navy camo": "#1a2a4a",
    "navy dip dye": "#13294b",
    "neon blue": "#1b9cff",
    "neon green": "#39ff14",
    "neon orange": "#ff5a00",
    "neon pink": "#ff6ec7",
    "neon pink glo": "#ff6ec7",
    "neon yellow": "#dfff00",
    "new break-up": "#4f5d3a",
    "new taupe": "#6b7a5a",
    "new taupe green": "#6b7a5a",
    nickel: "#727472",
    nights: "#1a2744",
    oasis: "#3cb371",
    oat: "#f5e6c8",
    "oat milk": "#f5e6c8",
    olive: "#556b2f",
    "olive drab": "#6b8e23",
    "olive drab green": "#6b8e23",
    "olive green": "#556b2f",
    "olive green heather": "#6b7a4a",
    "olive leaf": "#6b8e4e",
    orange: "#e87722",
    "orange blaze": "#ff6600",
    orchid: "#da70d6",
    oxford: "#9aa0a6",
    oyster: "#e0d8c8",
    palm: "#2e8b57",
    "palm trees": "#2e8b57",
    parcel: "#4a6fa5",
    "parcel blue": "#4a6fa5",
    "patriot blue": "#002868",
    "patriot blue digi": "#002868",
    peachy: "#ffdab9",
    photo: "#00bfff",
    "photo blue": "#00bfff",
    pink: "#e75480",
    "pink camo": "#c48a9a",
    "pool blue": "#39a0ca",
    powder: "#b0e0e6",
    "powder blue": "#b0e0e6",
    purple: "#5b2c6f",
    quarry: "#8b8c7a",
    quartz: "#f7cac9",
    "quiet shade gray": "#8a8a8a",
    "quiet shade gray heather": "#8a8a8a",
    "quiet shade grey": "#8a8a8a",
    "quiet shade grey heather": "#8a8a8a",
    rainstorm: "#6a6e71",
    "rainstorm gray": "#6a6e71",
    "rainstorm gray camo": "#6a6e71",
    "rainstorm grey": "#6a6e71",
    "rainstorm grey camo": "#6a6e71",
    "real tree max-7": "#5a6b3e",
    realtree: "#5a6b3e",
    "realtree advantage": "#5a6b3e",
    "realtree edge": "#4a5c3a",
    "realtree hardwoods": "#6b5b3e",
    "realtree max-7": "#5a6b3e",
    "realtree xtra": "#5a6b3e",
    red: "#c8102e",
    reflective: "#c0c0c0",
    "rich navy": "#13294b",
    "rich navy digi": "#13294b",
    rose: "#f7cac9",
    "rose quartz": "#f7cac9",
    rosewood: "#65000b",
    royal: "#1c3aa9",
    "royal camo": "#1c3aa9",
    safety: "#eed202",
    "safety  yellow": "#eed202",
    "safety yellow": "#eed202",
    sage: "#9caf88",
    "sage green": "#9caf88",
    sahara: "#c2a878",
    "saltwater duck camo": "#6a7a6a",
    sand: "#c2a878",
    "sand camo": "#c2a878",
    sandstone: "#c9b79c",
    sangria: "#92000a",
    sapphire: "#0f52ba",
    scarlet: "#ff2400",
    scotland: "#1c3aa9",
    "scotland blue": "#1c3aa9",
    shady: "#5a7a9a",
    "shady blue": "#5a7a9a",
    silver: "#c0c0c0",
    "silver heather": "#c0c0c0",
    "silver mist": "#c4c4c4",
    "sky blue": "#87ceeb",
    slate: "#708090",
    smoke: "#555555",
    "smoke blue": "#6a7b8a",
    snow: "#e8e8e8",
    "snow caps": "#e8e8e8",
    "soft blue": "#a7c7e7",
    "soft coral": "#f08080",
    spruce: "#0a5f38",
    stars: "#b22234",
    "stars stripes": "#b22234",
    steel: "#8a9196",
    "steel blue": "#4682b4",
    stone: "#c2b8a3",
    street: "#5a5a5a",
    stripe: "#1e4d8c",
    stripes: "#002868",
    sunflower: "#ffda03",
    "sunflower yellow": "#ffda03",
    tan: "#d2b48c",
    taupe: "#483c32",
    teal: "#008080",
    tidal: "#0088aa",
    "tidal blue": "#0088aa",
    timber: "#c4a484",
    "timber tan": "#c4a484",
    tnf: "#0b1c48",
    "tnf black": "#1a1a1a",
    "tnf black heather": "#2a2a2a",
    "tnf blue": "#0b1c48",
    "tnf dark gray heather": "#4a4a4a",
    "tnf dark grey": "#4a4a4a",
    "tnf dark grey heather": "#4a4a4a",
    "tnf medium gray heather": "#8a8a8a",
    "tnf medium grey": "#8a8a8a",
    "tnf medium grey heather": "#8a8a8a",
    "tnf yellow": "#ffd100",
    top: "#1c1c1c",
    trees: "#2e8b57",
    "tropic blue": "#009dc4",
    "true blue": "#1e4d8c",
    "true blue heather": "#3a5a8c",
    "true kelly": "#00a86b",
    "true kelly green": "#00a86b",
    "true royal": "#1c3aa9",
    "true royal heather": "#3a4a9a",
    turquoise: "#40e0d0",
    typhon: "#2f2f2f",
    "ultramarine blue": "#3f00ff",
    "urban navy": "#1a2744",
    "urban navy heather": "#1a2744",
    "valor blue": "#2e5090",
    "vegas gold": "#c5b358",
    vice: "#0055a5",
    "vice blue": "#0055a5",
    vintage: "#3a4a6a",
    "vintage indigo": "#3a4a6a",
    wave: "#4682b4",
    wheat: "#f5deb3",
    white: "#f5f5f5",
    wing: "#3a5f8a",
    winter: "#a8b0a8",
    "winter camo": "#a8b0a8",
    "woodland camo": "#4a5c3a",
    xtra: "#5a6b3e"
  };

  var ROOT_SEL =
    '.sancando-pdp--hats[data-testid="product-information"], .sancando-pdp--apparel[data-testid="product-information"]';
  var OBSERVE_THROTTLE_MS = 120;
  var CHANGE_THROTTLE_MS = 100;
  var observersStarted = false;
  var placeTimer = null;
  var changeTimer = null;

  function normalizePart(part) {
    return String(part || '')
      .toLowerCase()
      .replace(/\s+/g, ' ')
      .trim();
  }

  var META_HEX = null;
  // Multi-colour chips (El Jefe 2026-10-01 23:58, tie-dye): color_swatches[colour].parts = 2-3 photo hexes -> same diagonal split / wedge chip as "A/ B" colours; .hex stays the solid fallback.
  var META_PARTS = {};

  function loadMetaHex() {
    if (META_HEX) return META_HEX;
    META_HEX = {};
    var el = document.querySelector(
      '[data-testid="product-information"][data-color-swatches], [data-color-swatches]'
    );
    if (!el) return META_HEX;
    try {
      var raw = el.getAttribute('data-color-swatches');
      if (!raw) return META_HEX;
      var obj = JSON.parse(raw);
      Object.keys(obj).forEach(function (k) {
        var v = obj[k];
        var hex = v && typeof v === 'object' ? v.hex : typeof v === 'string' ? v : null;
        if (!hex) return;
        if (v && typeof v === 'object' && Array.isArray(v.parts)) {
          var ps = v.parts.filter(function (p) {
            return typeof p === 'string' && /^#[0-9a-f]{6}$/i.test(p);
          });
          if (ps.length >= 2) {
            META_PARTS[String(k)] = ps.slice(0, 4);
            META_PARTS[normalizePart(k)] = ps.slice(0, 4);
          }
        }
        META_HEX[String(k)] = hex;
        META_HEX[normalizePart(k)] = hex;
      });
    } catch (err) {}
    return META_HEX;
  }

  function hexForPart(part) {
    var meta = loadMetaHex();
    var key = normalizePart(part);
    if (meta[String(part)]) return meta[String(part)];
    if (meta[key]) return meta[key];
    if (COLOR_HEX[key]) return COLOR_HEX[key];
    var bits = key.split(' ');
    if (bits.length > 1 && COLOR_HEX[bits[bits.length - 1]]) {
      return COLOR_HEX[bits[bits.length - 1]];
    }
    return null;
  }

  function chipBackground(name) {
    var meta = loadMetaHex();
    var full = String(name || '');
    var multi = META_PARTS[full] || META_PARTS[normalizePart(full)] || null;
    if (!multi && meta[full]) return meta[full];
    var fullKey = normalizePart(full);
    if (!multi && meta[fullKey]) return meta[fullKey];
    var parts = multi ? [] : full
      .split('/')
      .map(function (p) {
        return p.trim();
      })
      .filter(Boolean);
    var hexes = multi
      ? multi.slice()
      : parts.map(hexForPart).filter(function (h) {
          return !!h;
        });
    if (hexes.length === 0) return null;
    if (hexes.length === 1) return hexes[0];
    // Same colour in every part (e.g. "Black/ Black"): draw a solid chip, no split line.
    var normHex = function (h) {
      var x = String(h).trim().toLowerCase();
      var m = /^#?([0-9a-f])([0-9a-f])([0-9a-f])$/.exec(x);
      if (m) return '#' + m[1] + m[1] + m[2] + m[2] + m[3] + m[3];
      return x.charAt(0) === '#' ? x : '#' + x;
    };
    var firstHex = normHex(hexes[0]);
    if (hexes.every(function (h) { return normHex(h) === firstHex; })) return hexes[0];
    if (hexes.length === 2) {
      return (
        'linear-gradient(135deg, ' +
        hexes[0] +
        ' 0 48%, rgba(255,255,255,.85) 48% 52%, ' +
        hexes[1] +
        ' 52% 100%)'
      );
    }
    var step = 100 / hexes.length;
    var stops = hexes
      .map(function (h, i) {
        var a = (i * step).toFixed(1);
        var b = ((i + 1) * step).toFixed(1);
        return h + ' ' + a + '% ' + b + '%';
      })
      .join(', ');
    return 'conic-gradient(from 210deg, ' + stops + ')';
  }

  function initialsFor(name) {
    var parts = String(name || '')
      .split(/[\/\s]+/)
      .filter(Boolean);
    if (!parts.length) return '?';
    if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
    return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
  }

  function isLightHex(bg) {
    if (!bg || bg.indexOf('gradient') !== -1) return false;
    var m = /^#([0-9a-f]{6})$/i.exec(bg);
    if (!m) return false;
    var n = parseInt(m[1], 16);
    var r = (n >> 16) & 255;
    var g = (n >> 8) & 255;
    var b = (n >> 0) & 255;
    return (r * 299 + g * 587 + b * 114) / 1000 > 180;
  }

  function selectedColorName(fieldset) {
    var checked = fieldset.querySelector('input[type="radio"]:checked');
    if (checked) return checked.value;
    var first = fieldset.querySelector('input[type="radio"]');
    return first ? first.value : '';
  }

  function updateToggle(fieldset) {
    var toggle = fieldset.querySelector('[data-sancando-hats-color-toggle]');
    if (!toggle) return;
    var name = selectedColorName(fieldset);
    var nameEl = toggle.querySelector('[data-sancando-hats-color-name]');
    var chipEl = toggle.querySelector('[data-sancando-hats-color-chip]');
    if (nameEl) nameEl.textContent = name || 'Color';
    if (chipEl) {
      var bg = chipBackground(name);
      if (bg) {
        chipEl.style.background = bg;
        chipEl.textContent = '';
        chipEl.classList.toggle('is-light', isLightHex(bg));
        chipEl.classList.remove('is-fallback');
      } else {
        chipEl.style.background = '#e8e8e8';
        chipEl.textContent = initialsFor(name);
        chipEl.classList.add('is-fallback');
        chipEl.classList.remove('is-light');
      }
    }
    toggle.setAttribute('aria-label', 'Selected color: ' + (name || 'Color'));
  }

  function findColorFieldset(picker) {
    var fieldsets = picker.querySelectorAll('fieldset.variant-option');
    var colorFieldset = null;
    for (var i = 0; i < fieldsets.length; i++) {
      var fs = fieldsets[i];
      var legend = fs.querySelector('legend');
      var labelText = legend ? legend.textContent.replace(/\s+/g, ' ').trim() : '';
      if (/^color\b/i.test(labelText) || labelText.toLowerCase() === 'color') {
        colorFieldset = fs;
        break;
      }
    }
    return colorFieldset;
  }

  function enhanceHatsColorPicker(root) {
    if (!root) return;
    var picker =
      root.querySelector('[data-sancando-hats-under-media] variant-picker') ||
      root.querySelector('variant-picker');
    if (!picker) return;

    var colorFieldset = findColorFieldset(picker);
    if (!colorFieldset) return;

    var already =
      picker.getAttribute('data-sancando-compact-color') === '1' &&
      colorFieldset.classList.contains('sancando-hats-color-fieldset') &&
      colorFieldset.querySelector('[data-sancando-hats-color-toggle]') &&
      colorFieldset.querySelectorAll('.sancando-hats-swatch').length > 0;
    if (already) {
      colorFieldset.classList.remove('is-collapsed');
      colorFieldset.classList.add('is-expanded');
      updateToggle(colorFieldset);
      return;
    }

    picker.setAttribute('data-sancando-compact-color', '1');
    colorFieldset.classList.add('sancando-hats-color-fieldset');

    var labels = colorFieldset.querySelectorAll('label.variant-option__button-label');
    for (var i = 0; i < labels.length; i++) {
      var label = labels[i];
      if (label.querySelector('.sancando-hats-swatch')) continue;
      var input = label.querySelector('input[type="radio"]');
      var name = input ? input.value : '';
      var swatch = document.createElement('span');
      swatch.className = 'sancando-hats-swatch';
      swatch.setAttribute('aria-hidden', 'true');
      var bg = chipBackground(name);
      if (bg) {
        swatch.style.background = bg;
        swatch.classList.toggle('is-light', isLightHex(bg));
      } else {
        swatch.classList.add('is-fallback');
        swatch.textContent = initialsFor(name);
      }
      label.insertBefore(swatch, label.firstChild);
      label.classList.add('sancando-hats-chip-label');
      label.title = name;
    }

    if (!colorFieldset.querySelector('[data-sancando-hats-color-toggle]')) {
      var toggle = document.createElement('div');
      toggle.className = 'sancando-hats-color-toggle';
      toggle.setAttribute('data-sancando-hats-color-toggle', '');
      toggle.setAttribute('role', 'status');
      toggle.innerHTML =
        '<span class="sancando-hats-color-toggle__chip" data-sancando-hats-color-chip aria-hidden="true"></span>' +
        '<span class="sancando-hats-color-toggle__text">Color: <strong data-sancando-hats-color-name></strong></span>';
      colorFieldset.insertBefore(toggle, colorFieldset.firstChild);
    }

    colorFieldset.classList.remove('is-collapsed');
    colorFieldset.classList.add('is-expanded');
    updateToggle(colorFieldset);

    if (!colorFieldset.getAttribute('data-sancando-compact-bound')) {
      colorFieldset.setAttribute('data-sancando-compact-bound', '1');
      colorFieldset.addEventListener('change', function () {
        updateToggle(colorFieldset);
        colorFieldset.classList.remove('is-collapsed');
        colorFieldset.classList.add('is-expanded');
      });
    }
  }

  function eachRoot(fn) {
    var roots = document.querySelectorAll(ROOT_SEL);
    for (var i = 0; i < roots.length; i++) {
      try {
        fn(roots[i]);
      } catch (err) {
        /* keep other roots healthy */
      }
    }
  }

  /* SanCanDo 2026-09-29: moving a connected <variant-picker> re-runs Horizon's connectedCallback,
     which adds a second 'change' -> variantChanged listener (never removed). Every colour click then
     fetched the section twice and aborted the first ("signal is aborted without reason").
     Skip only that one re-attach during the move; the rest of connectedCallback still runs. */
  function movePicker(slot, picker) {
    if (!picker.isConnected) {
      slot.appendChild(picker);
      return;
    }
    picker.addEventListener = function (type, fn, opts) {
      if (type === 'change' && fn && fn.name === 'bound variantChanged') return;
      return EventTarget.prototype.addEventListener.call(this, type, fn, opts);
    };
    try {
      slot.appendChild(picker);
    } finally {
      delete picker.addEventListener;
    }
  }

  function placeHatsVariantPicker() {
    eachRoot(function (root) {
      var slot = root.querySelector('[data-sancando-hats-under-media]');
      if (!slot) return;
      if (slot.querySelector('variant-picker')) {
        root.classList.add('sancando-hats-colors-placed');
        enhanceHatsColorPicker(root);
        return;
      }
      var picker = root.querySelector('.product-details variant-picker');
      if (!picker) return;
      movePicker(slot, picker);
      root.classList.add('sancando-hats-colors-placed');
      enhanceHatsColorPicker(root);
    });
  }

  function schedulePlace() {
    if (placeTimer) return;
    placeTimer = setTimeout(function () {
      placeTimer = null;
      try {
        placeHatsVariantPicker();
      } catch (err) {
        /* swallow */
      }
    }, OBSERVE_THROTTLE_MS);
  }

  function startObservers() {
    if (observersStarted || typeof MutationObserver === 'undefined') return;
    observersStarted = true;

    eachRoot(function (root) {
      var slot = root.querySelector('[data-sancando-hats-under-media]');
      if (slot && !slot.getAttribute('data-sancando-hats-mo')) {
        slot.setAttribute('data-sancando-hats-mo', '1');
        new MutationObserver(function () {
          var p = slot.querySelector('variant-picker');
          if (p && !slot.querySelector('[data-sancando-hats-color-toggle]')) {
            p.removeAttribute('data-sancando-compact-color');
          }
          schedulePlace();
        }).observe(slot, { childList: true, subtree: true });
      }

      var details = root.querySelector('.product-details');
      if (details && !details.getAttribute('data-sancando-hats-mo')) {
        details.setAttribute('data-sancando-hats-mo', '1');
        new MutationObserver(function () {
          schedulePlace();
        }).observe(details, { childList: true, subtree: false });
      }
    });
  }

  function onVariantChange(e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (!t.closest('.sancando-pdp--hats, .sancando-pdp--apparel')) return;
    if (!t.closest('variant-picker')) return;
    if (changeTimer) return;
    changeTimer = setTimeout(function () {
      changeTimer = null;
      eachRoot(function (root) {
        var p = root.querySelector('[data-sancando-hats-under-media] variant-picker');
        if (p && !root.querySelector('[data-sancando-hats-color-toggle]')) {
          p.removeAttribute('data-sancando-compact-color');
        }
        enhanceHatsColorPicker(root);
      });
    }, CHANGE_THROTTLE_MS);
  }

  /* SanCanDo 2026-09-30 (perf r3): Horizon morphs the picker back to server markup on every colour
     click (~0.5 s later, when the section fetch lands), which strips the chips/toggle this file adds.
     The MO/change timers above re-added them 100-120 ms later, after a paint of the raw 90-chip list
     (CLS 0.25 at 390). Re-enhance in the same task instead: ProductSelectEvent.promise resolves right
     after the morph, so its .then runs as a microtask before the next paint. One call per click,
     no new observer; the timers stay as a fallback (they no-op once enhanced). */
  function onProductSelect(e) {
    var t = e && e.target;
    if (!t || !t.closest || !t.closest('.sancando-pdp--hats, .sancando-pdp--apparel')) return;
    var pr = e.promise;
    if (!pr || typeof pr.then !== 'function') return;
    pr.then(
      function () {
        eachRoot(function (root) {
          if (!root.querySelector('[data-sancando-hats-under-media] variant-picker')) return;
          enhanceHatsColorPicker(root);
        });
      },
      function () {
        /* aborted fetch: the next click's promise handles it */
      }
    );
  }

  function boot() {
    try {
      placeHatsVariantPicker();
      startObservers();
    } catch (err) {
      /* antifreeze: never block paint */
    }
  }

  function scheduleBoot() {
    // One rAF so first paint of media wins, then idle with ≤500ms timeout.
    function afterPaint() {
      if (typeof requestIdleCallback === 'function') {
        requestIdleCallback(
          function () {
            boot();
          },
          { timeout: 500 }
        );
      } else {
        setTimeout(boot, 0);
      }
    }
    if (typeof requestAnimationFrame === 'function') {
      requestAnimationFrame(function () {
        requestAnimationFrame(afterPaint);
      });
    } else {
      afterPaint();
    }
  }

  document.addEventListener('shopify:section:load', function () {
    try {
      placeHatsVariantPicker();
      startObservers();
    } catch (err) {
      /* swallow */
    }
  });
  document.addEventListener('shopify:section:reorder', function () {
    try {
      placeHatsVariantPicker();
    } catch (err) {
      /* swallow */
    }
  });
  document.addEventListener('change', onVariantChange, false);
  document.addEventListener('shopify:product:select', onProductSelect, true);

  try {
    scheduleBoot();
  } catch (err) {
    setTimeout(boot, 0);
  }
})();
